module.exports = __webpack_public_path__ + "static/media/swimming.2ab46470.svg";